<div class="tm-modal-header">
  <button *ngIf="modal.showClose" attr.aria-label="{{modal.closeBtnAriaLabel}}" class="tm-modal-close" (click)="modal.close(modal.CLOSE_REASON.CLOSE)" type="button"><span aria-hidden="true">×</span></button>
  <ng-content #customTemp></ng-content>
  <ng-container *ngIf="!headerTemp">
    <h1 class="tm-modal-title" mat-dialog-title>{{ modal.title }}</h1>
  </ng-container>
</div>
